import script from "./ProcViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcViewPage.vue?vue&type=script&setup=true&lang=js"

import "./ProcViewPage.vue?vue&type=style&index=0&id=39e03216&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e03216"]])

export default __exports__